<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon"  [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faClipboardList"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.testmanager' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'testManager.toolHeaderLine1' | translate}}<br>
          {{'testManager.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTM">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span (click)="generateReport('true')">
                <fa-icon class="fas fa-lg cursorPointer" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
        <!-- <div class="dropGroupBtn marginbottom5px">
          <span>
            <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTM">
              <fa-icon class="fas" [icon]="faInfo"></fa-icon>
            </a>
          </span>
        </div>
        <div class="dropGroupBtn marginbottom5px">
          <span (click)="generateReport('true')">
            <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
          </span>
        </div> -->
        <!-- <div class="dropdown" role="group">
      <button class="btn btn-primary btn-xs dropdown-toggle dropGroupBtn" type="button" id="dropdownMenu1"
       data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
       View
       <span class="caret"></span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu1">
       <li>
        <a href="/export" target="_blank" (click)="generateReport()">View
        </a>
       </li>
       <li>
        <a (click)="">Download
        </a>
       </li>
      </ul>
     </div> -->
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="test-manager tool-body-height menuItemsClrWhite">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="h-100">
        <div class="row strict h-100 card bg-white pb-0">
          <div class="row strict">
            <ul class="nav nav-tabs">
              <li class="active" id="scenarioTabId" (click)="switchTab('scenarios');generateAttriStatus()">
                <a data-toggle="tab" ng-attr-data-target="#scenarios">{{ 'testManager.scenarioTab' | translate
                  }}&nbsp;({{modelData.scenarios.length}})</a>
              </li>
              <li id="suiteTabId" (click)="switchTab('suites')">
                <a data-toggle="tab" ng-attr-data-target="#suites">{{ 'testManager.suiteTab' | translate
                  }}&nbsp;({{modelData.suites.length}})</a>
              </li>
            </ul>
          </div>
          <div class="tab-content test-manager-nav-tab-content-height card ">
            <!-- scenarios tab start -->
            <div *ngIf="activeTab == 'scenarios'" class="tab-pane fade in active h-100 border-1px">
              <div class="row p-2">
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                  <label class="radio-inline text-color-white">
                    <input class="checkboxReadOnly" type="radio" value="Entity" (click)="changeRadio('Entity')"
                      name="managerradios" [(ngModel)]="scenarioFilter" checked>
                    &nbsp;&nbsp;{{ 'testManager.entityRadio' | translate }}
                  </label>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                  <label class="radio-inline text-color-white">
                    <input class="checkboxReadOnly" type="radio" value="EUT" (click)="changeRadio('EUT')"
                      name="managerradios" [(ngModel)]="scenarioFilter">&nbsp;&nbsp;{{ 'testManager.eutRadio' |
                    translate }}</label>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                  <label class="radio-inline text-color-white">
                    <input class="checkboxReadOnly" type="radio" value="Test" (click)="changeRadio('Test')"
                      name="managerradios" [(ngModel)]="scenarioFilter">&nbsp;&nbsp;{{ 'testManager.testRadio' |
                    translate }}</label>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                  <label class="radio-inline text-color-white">
                    <input class="checkboxReadOnly" type="radio" value="Levels" (click)="changeRadio('Levels')"
                      name="managerradios" [(ngModel)]="scenarioFilter">&nbsp;&nbsp;{{ 'testManager.levelsRadio' |
                    translate }}</label>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                  <label class="radio-inline text-color-white">
                    <input class="checkboxReadOnly" type="radio" value="Module" (click)="changeRadio('Module')"
                      name="managerradios" [(ngModel)]="scenarioFilter">&nbsp;&nbsp;{{ 'testManager.moduleRadio' |
                    translate }}</label>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                  <label class="radio-inline text-color-white">
                    <input class="checkboxReadOnly" type="radio" value="Suites" (click)="changeRadio('Suites')"
                      name="managerradios" [(ngModel)]="scenarioFilter">&nbsp;&nbsp;{{ 'testManager.suiteRadio' |
                    translate }}</label>
                </div>
              </div>
              <div class="row strict test-manager-tab-content-table-height">
                <div class="row strict h-100" *ngIf="scenarioFilter=='Entity'">
                  <div class="row strict h-50">
                    <table class="table table-bordered ui-sort-table scenario-table tableBackgrdClrBlack cursorArrow">
                      <thead class="">
                        <tr>
                          <th class="col-xs-10">
                            <div>
                              {{ 'testManager.Entitytypedistribution' | translate }}
                            </div>
                          </th>
                          <th class="col-xs-1">
                            {{ 'testManager.count' | translate }}
                          </th>
                          <th class="col-xs-1">
                            {{ 'testManager.total' | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="test-manager-entity-table-body-height cursorArrow">
                        <tr>
                          <td class="col-xs-10">{{ 'testManager.TF' | translate }}</td>
                          <td class="col-xs-1">{{totalTFCount}}</td>
                          <td class="col-xs-1">{{AttributestatusTF}}%</td>
                        </tr>
                        <tr>
                          <td class="col-xs-10">{{ 'testManager.BF' | translate }}</td>
                          <td class="col-xs-1">{{totalBFCount}}</td>
                          <td class="col-xs-1">{{AttributestatusBF}}%</td>
                        </tr>
                        <tr>
                          <td class="col-xs-10">{{ 'testManager.UR' | translate }}</td>
                          <td class="col-xs-1">{{totalURCount}}</td>
                          <td class="col-xs-1">{{AttributestatusUR}}%</td>
                        </tr>
                        <tr>
                          <td class="col-xs-10">{{ 'testManager.XX' | translate }}</td>
                          <td class="col-xs-1">{{totalXXCount}}</td>
                          <td class="col-xs-1">{{AttributestatusXX}}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row strict h-50">
                    <table class="table table-bordered ui-sort-table scenario-table tableBackgrdClrBlack cursorArrow">
                      <thead class="">
                        <tr>
                          <th class="col-xs-7">
                            <div>
                              {{ 'testManager.Scenariobyentitytype' | translate }}
                            </div>
                          </th>
                          <th class="col-xs-1">
                            {{ 'testManager.count' | translate }}
                          </th>
                          <th class="col-xs-1">
                            +ve
                          </th>
                          <th class="col-xs-1">
                            -ve
                          </th>
                          <th class="col-xs-1">
                            {{ 'testManager.total' | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="test-manager-entity-table-body-height">
                        <tr>
                          <td class="col-xs-7">{{ 'testManager.TF' | translate }}</td>
                          <td class="col-xs-1">{{scenarioTF}}</td>
                          <td class="col-xs-1">{{scenarioTFPositive}}</td>
                          <td class="col-xs-1">{{scenarioTFNegative}}</td>
                          <td class="col-xs-1">{{scenarioTFStatus}}%</td>
                        </tr>
                        <tr>
                          <td class="col-xs-7">{{ 'testManager.BF' | translate }}</td>
                          <td class="col-xs-1">{{scenarioBF}}</td>
                          <td class="col-xs-1">{{scenarioBFPositive}}</td>
                          <td class="col-xs-1">{{scenarioBFNegative}}</td>
                          <td class="col-xs-1">{{scenarioBFStatus}}%</td>
                        </tr>
                        <tr>
                          <td class="col-xs-7">{{ 'testManager.UR' | translate }}</td>
                          <td class="col-xs-1">{{scenarioUR}}</td>
                          <td class="col-xs-1">{{scenarioURPositive}}</td>
                          <td class="col-xs-1">{{scenarioURNegative}}</td>
                          <td class="col-xs-1">{{scenarioURStatus}}%</td>
                        </tr>
                        <tr>
                          <td class="col-xs-7">{{ 'testManager.XX' | translate }}</td>
                          <td class="col-xs-1">{{scenarioXX}}</td>
                          <td class="col-xs-1">{{scenarioXXPositive}}</td>
                          <td class="col-xs-1">{{scenarioXXNegative}}</td>
                          <td class="col-xs-1">{{scenarioXXStatus}}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row strict h-100 cursorArrow" *ngIf="scenarioFilter !='Entity'">
                  <table
                    class="table table-bordered ui-sort-table env1 scenario-table h-100 card p-1 mb-2 bg-white tableBackgrdClrBlack ">
                    <thead class="">
                      <tr>
                        <th class="col-xs-9">
                          <div class="row strict" *ngIf="scenarioFilter == 'EUT'">
                            <div class="dropdown col-xs-12">
                              <button
                                class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                                type="button" data-toggle="dropdown">
                                <div class="row strict">
                                  <div class="col-xs-11 span-on-button ">
                                    EUT({{selectedEntity}})
                                  </div>
                                  <div class="col-xs-1 pull-right ">
                                    <span class="caret"></span>
                                  </div>
                                </div>
                              </button>
                              <ul class="dropdown-menu">
                                <li (click)="choseEntity('TF')">
                                  <a>{{'entities.Fe' | translate}}</a>
                                </li>
                                <li (click)="choseEntity('UR')">
                                  <a>{{'entities.Ur' | translate}}</a>
                                </li>
                                <li (click)="choseEntity('BF')">
                                  <a>{{'entities.Bf' | translate}}</a>
                                </li>
                                <li (click)="choseEntity('XX')">
                                  <a>{{'entities.Xx' | translate}}</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div *ngIf="scenarioFilter!='EUT'">
                            Scenarios by {{scenarioFilter | lowercase}}
                          </div>
                          <!-- <div *ngIf="scenarioFilter!='Entity'">
                            Scenarios by {{scenarioFilter | lowercase}}
                          </div> -->
                        </th>
                        <th class="col-xs-1">
                          {{ 'testManager.count' | translate }}
                        </th>
                        <th *ngIf="scenarioFilter!='Entity'" class="col-xs-1">
                          +ve
                        </th>
                        <th *ngIf="scenarioFilter!='Entity'" class="col-xs-1">
                          -ve
                        </th>
                        <th class="col-xs-1">
                          {{ 'testManager.total' | translate }}
                        </th>
                      </tr>
                    </thead>

                    <tbody class="test-manager-eut-table-body-height" *ngIf="scenarioFilter=='EUT'">
                      <tr *ngFor="let e of modelData.listOfEUTs">
                        <td *ngIf="selectedEntity == e.eType" class="col-xs-9">{{getModuleName(e)}} | {{e.eName}}</td>
                        <td *ngIf="selectedEntity == e.eType" class="col-xs-1">{{getCountForEntity(e).count}}</td>
                        <td *ngIf="selectedEntity == e.eType" class="col-xs-1">{{getCountForEntity(e).positive}}</td>
                        <td *ngIf="selectedEntity == e.eType" class="col-xs-1">{{getCountForEntity(e).negative}}</td>
                        <td *ngIf="selectedEntity == e.eType" class="col-xs-1">{{getCountForEntity(e).percent}}%</td>
                      </tr>
                    </tbody>
                    <tbody class="test-manager-test-table-body-height" *ngIf="scenarioFilter=='Test'">
                      <tr *ngFor="let a of config.listOfAttributesUpdated">
                        <td class="col-xs-9">{{a.name}}</td>
                        <td class="col-xs-1">{{getCountForTestType(a).count}}</td>
                        <td class="col-xs-1">{{getCountForTestType(a).positive}}</td>
                        <td class="col-xs-1">{{getCountForTestType(a).negative}}</td>
                        <td class="col-xs-1">{{getCountForTestType(a).percent}}%</td>
                      </tr>
                    </tbody>
                    <tbody class="test-manager-persona-table-body-height" *ngIf="scenarioFilter=='Module'">
                      <tr *ngFor="let m of modelData.modules">
                        <td class="col-xs-9">{{m.mName}}</td>
                        <td class="col-xs-1">{{getCountForModule(m.mID).count}}</td>
                        <td class="col-xs-1">{{getCountForModule(m.mID).positive}}</td>
                        <td class="col-xs-1">{{getCountForModule(m.mID).negative}}</td>
                        <td class="col-xs-1">{{getCountForModule(m.mID).percent}}%
                        </td>
                      </tr>
                    </tbody>

                    <tbody class="test-manager-levels-table-body-height" *ngIf="scenarioFilter=='Levels'">
                      <tr *ngFor="let a of config.levels">
                        <td class="col-xs-9">{{a}}</td>
                        <td class="col-xs-1">{{getCountForLevel(a).count}}</td>
                        <td class="col-xs-1">{{getCountForLevel(a).positive}}</td>
                        <td class="col-xs-1">{{getCountForLevel(a).negative}}</td>
                        <td class="col-xs-1">{{getCountForLevel(a).percent}}%</td>
                      </tr>
                    </tbody>
                    <tbody class="test-manager-suites-table-body-height" *ngIf="scenarioFilter=='Suites'">
                      <tr *ngFor="let suite of modelData.suites">
                        <td class="col-xs-9">{{suite.suiteName}}</td>
                        <td class="col-xs-1">{{getCountForSuites(suite).count}}</td>
                        <td class="col-xs-1">{{getCountForSuites(suite).positive}}</td>
                        <td class="col-xs-1">{{getCountForSuites(suite).negative}}</td>
                        <td class="col-xs-1">{{getCountForSuites(suite).percent}}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- scenarios tab end -->
            <!-- suites tab start *ngIf="showText == true" -->
            <div *ngIf="activeTab == 'suites'" class="tab-pane fade in active h-100">
              <div class="row strict h-100">
                <div class="row full-width p-0">
                  <div class="col-xs-9 btn-padding pl-0 pr-2">
                    <div *ngIf="showText == false" class="dropdown">
                      <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-10 span-on-button ">
                            <span *ngIf="modelData.suites.length>0"><span
                                *ngIf="selectedSuite.suiteName">{{selectedSuite.suiteName}}</span>
                              <span *ngIf="!selectedSuite.suiteName">{{'testManager.choosesuitename' |
                                translate}}</span>
                            </span>
                            <span *ngIf="modelData.suites.length <= 0">{{'testManager.addasuite' | translate}}</span>
                          </div>
                          <div class="col-xs-1 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu" *ngIf="modelData.suites.length > 0">
                        <li (click)="chooseSuite(false,false,suite)" *ngFor="let suite of modelData.suites">
                          <a>{{suite.suiteName}}</a>
                        </li>
                      </ul>
                    </div>
                    <div *ngIf="showText == true">
                      <input type="text" (keyup.enter)="saveSuite(suiteName,oldSuiteName, updateSuitename)"
                        [placeholder]="'testManager.enterasuite'|translate" [(ngModel)]="suiteName" id="addSuiteName"
                        class="form-control strict lg-input pl-3 pr-3 suites-inputfield">
                    </div>
                  </div>
                  <div class="col-xs-2 btn-padding pr-0">
                    <div class="row strict">
                      <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                        <div>
                          <button type="button" (click)="chooseSuite(true,true,{})"
                            class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                            <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                          </button>
                        </div>
                      </div>
                      <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                        <div>
                          <button type="button" (click)="editSuite(selectedSuite.suiteName)"
                            class="btn btn-block btn-default btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                            <fa-icon class="fas icon-black" [icon]="faEdit"></fa-icon>
                          </button>
                        </div>
                      </div>
                      <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                        <div *ngIf="showText == false">
                          <button type="button" data-toggle="modal" data-target="#suiteDeleteConfirmModel"
                            class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                            <fa-icon class="fas icon-black" [icon]="faTrash"></fa-icon>
                          </button>
                        </div>
                        <div *ngIf="showText == true">
                          <button type="button" (click)="clear()"
                            class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                            <fa-icon class="fas icon-black" [icon]="faTimes"></fa-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row strict test-manager-suites-scenarios-tab-total-table-part-height">
                  <div class="row strict h-55">
                    <div class="row strict test-manager-suites-scenarios-part-height pt-2">
                      <div class="col-xs-12 h-100">
                        <div class="row strict p-0 h-100">
                          <div class="row strict h-100">
                            <table
                              class="table table-bordered border-1px ui-sort-table env1 tableBackgrdClrBlack h-100">
                              <thead class="">
                                <tr class="border-bottom1px">
                                  <th class="col-xs-1 mapperReadOnly">
                                    <div style="text-align: center;">
                                      <input type="checkbox" class="cursorPointer" id="selectAllAdd"
                                        (click)="addAllFromScenarios($event.target.checked)">
                                    </div>
                                  </th>
                                  <th class="col-xs-4 cursorArrow">
                                    {{'testManager.projectScenarios' | translate}}
                                    <!-- <span *ngIf="selectedSuite.suiteName != ''">({{matchedScenarioCount}})</span>
                                    <span *ngIf="selectedSuite.suiteName == ''">(0)</span> -->
                                  </th>
                                  <th class="col-xs-1">
                                    <div class="dropdown">
                                      <button
                                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                        type="button" data-toggle="dropdown">
                                        <div class="row strict">
                                          <div class="col-xs-7 span-on-button">
                                            Modules
                                          </div>
                                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                            <span class="caret"></span>
                                          </div>
                                        </div>
                                      </button>
                                      <ul class="dropdown-menu text-color-black w-200">
                                        <li class="row padding-vertical" *ngFor="let m of modelData.modules">
                                          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToPersonaFilter(m.mID,$event.target.checked)"
                                                type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 dropdown-item cursorArrow">
                                            {{m.mName}}
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </th>
                                  <th class="col-xs-1">
                                    <div class="dropdown">
                                      <button
                                        class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                        type="button" data-toggle="dropdown">
                                        <div class="row strict">
                                          <div class="col-xs-10">
                                            <span>Type</span>
                                          </div>
                                          <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                            <span class="caret"></span>
                                          </div>
                                        </div>
                                      </button>
                                      <ul class="dropdown-menu text-color-black minwidth-100">
                                        <li class="row strict" *ngFor="let eut of eutTypes">
                                          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToEntityTypeFilter(eut,$event.target.checked)"
                                                type="checkbox">
                                            </div>
                                          </div>
                                          <div class="col-xs-10 col-xs-offset-1 dropdown-item cursorArrow">
                                            {{eut}}
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </th>
                                  <th class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                                    <div class="dropdown">
                                      <button
                                        class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                        type="button" data-toggle="dropdown">
                                        <div class="row strict">
                                          <div class="col-xs-10 span-on-button ">
                                            {{'testManager.entities' | translate}}
                                          </div>
                                          <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                            <span class="caret"></span>
                                          </div>
                                        </div>
                                      </button>
                                      <ul class="dropdown-menu text-color-black w-250">
                                        <li class="row padding-vertical" *ngFor="let eut of modelData.listOfEUTs">
                                          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToEntityFilter(eut.eID,$event.target.checked)"
                                                type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item cursorArrow">
                                            {{getModuleName(eut)}} | {{eut.eName}}
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </th>
                                  <th class="col-xs-1">
                                    <div class="dropdown">
                                      <button
                                        class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                        type="button" data-toggle="dropdown">
                                        <div class="row strict">
                                          <div class="col-xs-7 span-on-button ">
                                            {{'testManager.attributes' | translate}}
                                          </div>
                                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                            <span class="caret"></span>
                                          </div>
                                        </div>
                                      </button>
                                      <ul class="dropdown-menu text-color-black w-300">
                                        <li class="row padding-vertical"
                                          *ngFor="let a of Config.listofFunctionalityTestTypes">
                                          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToAttributeFilter(a.symbol,$event.target.checked)"
                                                type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                            {{a.name+" ("+a.symbol+")"}}
                                          </div>
                                        </li>
                                        <li class="row padding-vertical" *ngFor="let a of listOfAttributes">
                                          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToAttributeFilter(a.symbol,$event.target.checked)"
                                                type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                            {{a.name+" ("+a.symbol+")"}}
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </th>
                                  <th class="col-xs-1">
                                    <div class="dropdown">
                                      <button
                                        class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                        type="button" data-toggle="dropdown">
                                        <div class="row strict">
                                          <div class="col-xs-7 span-on-button ">
                                            Levels
                                          </div>
                                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                            <span class="caret"></span>
                                          </div>
                                        </div>
                                      </button>
                                      <ul class="dropdown-menu text-color-black minwidth-100">
                                        <li class="row padding-vertical" *ngFor="let a of config.levels">
                                          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToPriorityFilter(a,$event.target.checked)" type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 dropdown-item cursorArrow">
                                            {{a}}
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </th>
                                  <th class="col-xs-1">
                                    <div class="dropdown">
                                      <button
                                        class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                        type="button" data-toggle="dropdown">
                                        <div class="row strict">
                                          <div class="col-xs-7 span-on-button ">
                                            +/-
                                          </div>
                                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                            <span class="caret"></span>
                                          </div>
                                        </div>
                                      </button>
                                      <ul class="dropdown-menu dropdown-menu-right text-color-black minwidth-100">
                                        <li class="row padding-vertical">
                                          <div
                                            class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 col-xl-1 col-xl-offset-1">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToCrFilter('+',$event.target.checked)" type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-7 col-xs-offset-1 col-sm-7 col-sm-offset-1 col-md-7 col-md-offset-1 col-lg-7 col-lg-offset-1 col-xl-9 col-xl-offset-1 dropdown-item cursorArrow">
                                            +
                                          </div>
                                        </li>
                                        <li class="row padding-vertical">
                                          <div
                                            class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 col-xl-1 col-xl-offset-1">
                                            <div style="text-align: center;">
                                              <input class="checkboxReadOnly cursorPointer"
                                                (click)="addToCrFilter('-',$event.target.checked)" type="checkbox">
                                            </div>
                                          </div>
                                          <div
                                            class="col-xs-7 col-xs-offset-1 col-sm-7 col-sm-offset-1 col-md-7 col-md-offset-1 col-lg-7 col-lg-offset-1 col-xl-9 col-xl-offset-1 dropdown-item cursorArrow">
                                            -
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <!-- |testmanagerprojectfilter:attributeSelected:prioritySelected:crSelected:moduleSelected:eutSelected:selectedEUT:filterTypeList; -->
                              <tbody class="suite-table test-manager-suites-scenarios-part-table-body-height"
                                style="height: 150px !important;">
                                <tr class="border-bottom1px cursorArrow"
                                  *ngFor="let scenario of modelData.scenarios|testmanagerprojectfilter:attributeSelected:prioritySelected:crSelected:moduleSelected:eutSelected:eutTypeSelected:selectedSuite:filterTypeList:modelData.listOfEUTs">
                                  <td class="text-flow col-xs-1 border-right1px">
                                    <div style="text-align: center;">
                                      <input type="checkbox" [checked]="topSelectedList.indexOf(scenario.scenID)>-1"
                                        class="mapperReadOnly cursorPointer" (click)="toggleSelection(scenario.scenID)">
                                    </div>
                                  </td>
                                  <td class="text-flow col-xs-4 border-right1px">
                                    {{scenario.description}}
                                  </td>
                                  <td class="col-xs-1 no-padding border-right1px">
                                    {{getModuleNameByeID(scenario.eID)}}
                                  </td>
                                  <td class="text-flow col-xs-1 border-right1px">
                                    {{getEntity(scenario.eID).eType}}
                                  </td>
                                  <td class="text-flow col-xs-2 col-sm-2 col-lg-2 col-md-2 border-right1px">
                                    {{getEntity(scenario.eID).eName}}
                                  </td>
                                  <td class="text-flow col-xs-1 border-right1px">
                                    {{scenario.tID}}
                                  </td>
                                  <td class="text-flow col-xs-1border-right1px">
                                    {{scenario.attribute.level}}
                                  </td>
                                  <td class="text-flow col-xs-1">
                                    {{scenario.cr}}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row strict p-2 menuItemsClrBlack height33px">
                      <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                      </div>
                      <div class="col-xs-3">
                        <button class="w-100 labelReadOnly height23px" type="button" (click)="addScenariosToSuite()"
                          class="btn btn-default btn-xs">
                          <span><i class="fa fa-angle-double-down icon-black"></i>&nbsp;{{'testManager.Addtosuite' |
                            translate}}({{topSelectedList.length}})</span>
                        </button>
                      </div>
                      <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                      </div>
                      <div class="col-xs-3">
                        <button class="w-100 labelReadOnly height23px" type="button" (click)="removeScenariosToSuite()"
                          class="btn btn-default btn-xs">
                          <span>{{'testManager.Removefromsuite' | translate}}({{bottomSelectedList.length}})&nbsp;<i
                              class="fa fa-angle-double-up icon-black"></i></span>
                        </button>
                      </div>
                      <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                      </div>
                    </div>
                  </div>
                  <div class="h-45">
                    <div class="row strict h-100">
                      <div class="col-xs-12 h-100">
                        <!-- <div class="row strict p-1">
                          <span class="menuItemsClrWhite"> <span
                              *ngIf="selectedSuite.suiteName">{{selectedSuite.suiteName}}</span>
                            <span
                              *ngIf="!selectedSuite.suiteName">{{'testManager.suite' | translate}}</span>
                          </span>
                          <span
                            class="menuItemsClrWhite">({{matchedSuiteScenarioCount||0}})</span>
                        </div> -->
                        <div class="row strict h-100">
                          <!-- test-manager-suites-suite-part-table-height -->
                          <table class="table table-bordered border-1px ui-sort-table env1 h-100 tableBackgrdClrBlack">
                            <thead class="">
                              <tr>
                                <th class="col-xs-1">
                                  <div style="text-align: center;">
                                    <input type="checkbox" class="cursorPointer" id="selectAllRemove"
                                      (click)="addAllFromSuite($event.target.checked)">
                                  </div>
                                </th>
                                <th class="col-xs-4">
                                  {{'testManager.suiteScenarios' | translate}}
                                  <!-- <span *ngIf="selectedSuite.suiteName != ''">({{matchedSuiteScenarioCount}})</span>
                                  <span *ngIf="selectedSuite.suiteName == ''">(0)</span> -->
                                </th>

                                <th class="col-xs-1">
                                  <!-- {{'testManager.user' | translate}} -->
                                  <div class="dropdown">
                                    <button
                                      class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                      type="button" data-toggle="dropdown">
                                      <div class="row strict">
                                        <div class="col-xs-7 span-on-button ">
                                          Modules
                                        </div>
                                        <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                          <span class="caret"></span>
                                        </div>
                                      </div>
                                    </button>
                                    <ul class="dropdown-menu text-color-black w-200">
                                      <li class="row padding-vertical" *ngFor="let m of modelData.modules">
                                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToModuleFilterSuite(m.mID,$event.target.checked)"
                                              type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 dropdown-item cursorArrow">
                                          {{m.mName}}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </th>
                                <th class="col-xs-1">
                                  <!-- {{'testManager.eType' | translate}} -->
                                  <div class="dropdown">
                                    <button
                                      class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                      type="button" data-toggle="dropdown">
                                      <div class="row strict">
                                        <div class="col-xs-10">
                                          <span>Type</span>
                                        </div>
                                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                          <span class="caret"></span>
                                        </div>
                                      </div>
                                    </button>
                                    <ul class="dropdown-menu text-color-black minwidth-100">
                                      <li class="row strict" *ngFor="let eut of eutTypes">
                                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToEntityTypeFilterSuite(eut,$event.target.checked)"
                                              type="checkbox">
                                          </div>
                                        </div>
                                        <div class="col-xs-10 col-xs-offset-1 dropdown-item cursorArrow"
                                          (click)="changeEntitySuite(eut)">
                                          {{eut}}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </th>
                                <th class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
                                  <!-- EUT -->
                                  <div class="dropdown">
                                    <button
                                      class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                      type="button" data-toggle="dropdown">
                                      <div class="row strict">
                                        <div class="col-xs-10 span-on-button ">
                                          {{'testManager.entities' | translate}}
                                        </div>
                                        <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                          <span class="caret"></span>
                                        </div>
                                      </div>
                                    </button>
                                    <ul class="dropdown-menu text-color-black w-250">
                                      <li class="row padding-vertical" *ngFor="let eut of modelData.listOfEUTs">
                                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToEntityFilterSuite(eut.eID,$event.target.checked)"
                                              type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item cursorArrow">
                                          {{getModuleName(eut)}} | {{eut.eName}}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </th>
                                <th class="col-xs-1">
                                  <!-- TT -->
                                  <div class="dropdown">
                                    <button
                                      class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                      type="button" data-toggle="dropdown">
                                      <div class="row strict">
                                        <div class="col-xs-7 span-on-button ">
                                          {{'testManager.attributes' | translate}}
                                        </div>
                                        <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                          <span class="caret"></span>
                                        </div>
                                      </div>
                                    </button>
                                    <ul class="dropdown-menu text-color-black w-300">
                                      <li class="row padding-vertical"
                                        *ngFor="let a of Config.listofFunctionalityTestTypes">
                                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToAttributeFilterSuite(a.symbol,$event.target.checked)"
                                              type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                          {{a.name+" ("+a.symbol+")"}}
                                        </div>
                                      </li>
                                      <li class="row padding-vertical" *ngFor="let a of listOfAttributes">
                                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToAttributeFilterSuite(a.symbol,$event.target.checked)"
                                              type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                          {{a.name+" ("+a.symbol+")"}}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </th>
                                <th class="col-xs-1">
                                  <!-- {{'testManager.priority' | translate}} -->
                                  <div class="dropdown">
                                    <button
                                      class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                      type="button" data-toggle="dropdown">
                                      <div class="row strict">
                                        <div class="col-xs-7 span-on-button ">
                                          Levels
                                        </div>
                                        <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                          <span class="caret"></span>
                                        </div>
                                      </div>
                                    </button>
                                    <ul class="dropdown-menu text-color-black minwidth-100">
                                      <li class="row padding-vertical" *ngFor="let a of config.levels">
                                        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToPriorityFilterSuite(a,$event.target.checked)"
                                              type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 dropdown-item cursorArrow">
                                          {{a}}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </th>
                                <th class="col-xs-1">
                                  <!-- +/- -->
                                  <div class="dropdown">
                                    <button
                                      class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                                      type="button" data-toggle="dropdown">
                                      <div class="row strict">
                                        <div class="col-xs-7 span-on-button ">
                                          +/-
                                        </div>
                                        <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                          <span class="caret"></span>
                                        </div>
                                      </div>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right text-color-black minwidth-100">
                                      <li class="row padding-vertical">
                                        <div
                                          class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 col-xl-1 col-xl-offset-1">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToCrFilterSuite('+',$event.target.checked)" type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-7 col-xs-offset-1 col-sm-7 col-sm-offset-1 col-md-7 col-md-offset-1 col-lg-7 col-lg-offset-1 col-xl-9 col-xl-offset-1 dropdown-item cursorArrow">
                                          +
                                        </div>
                                      </li>
                                      <li class="row padding-vertical">
                                        <div
                                          class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 col-xl-1 col-xl-offset-1">
                                          <div style="text-align: center;">
                                            <input class="checkboxReadOnly cursorPointer"
                                              (click)="addToCrFilterSuite('-',$event.target.checked)" type="checkbox">
                                          </div>
                                        </div>
                                        <div
                                          class="col-xs-7 col-xs-offset-1 col-sm-7 col-sm-offset-1 col-md-7 col-md-offset-1 col-lg-7 col-lg-offset-1 col-xl-9 col-xl-offset-1 dropdown-item cursorArrow">
                                          -
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <!-- *ngIf="((isPresentInCollectionSuite(testManager.model.scenarioModel.getScenario(sID.trim()).eID)||!(eutSelectedSuite.length > 0))&&
                (isPresentInMCollectionSuite(testManager.model.scenarioModel.getScenario(sID.trim()).persona)||!(personaSelectedSuite.length > 0))&&
                (isPresentInACollectionSuite(testManager.model.scenarioModel.getScenario(sID.trim()).tID)||!(attributeSelectedSuite.length > 0))&&
                (isPresentInPrCollectionSuite(testManager.model.scenarioModel.getScenario(sID.trim()).priority)||!(levelSelectedSuite.length > 0))&&
                (isPresentInCrCollectionSuite(testManager.model.scenarioModel.getScenario(sID.trim()).cr)||!(crSelectedSuite.length > 0))&&
                (isPresentInSuite(testManager.model.scenarioModel.getScenario(sID.trim()).scenID)||!(selectedSuite.scenarios.length > 0)))&&
                (getEntity(testManager.model.scenarioModel.getScenario(sID.trim()).eID).eType == selectedEUTSuite)" -->
                            <tbody class="suite-table test-manager-suites-suites-part-table-body-height"
                              style="height: 150px !important;">
                              <tr class="border-bottom1px cursorArrow"
                                *ngFor="let scenario of modelData.scenarios|testmanagersuitefilter:attributeSelectedSuite:levelSelectedSuite:crSelectedSuite:moduleSelectedSuite:eutSelectedSuite:eutTypeSelectedSuite:selectedSuite:filterTypeList:modelData.listOfEUTs">
                                <td class="text-flow col-xs-1">
                                  <div style="text-align: center;">
                                    <input type="checkbox" class="cursorPointer"
                                      [checked]="bottomSelectedList.indexOf(scenario.scenID)>-1"
                                      (click)="toggleSelectionInSuites(scenario.scenID)">
                                  </div>
                                </td>
                                <td class="text-flow col-xs-4 border-right1px">
                                  {{scenario.description}}
                                </td>
                                <td class="col-xs-1 no-padding border-right1px">
                                  {{getModuleNameByeID(scenario.eID)}}
                                </td>
                                <td class="text-flow col-xs-1 border-right1px">
                                  {{getEntity(scenario.eID).eType}}
                                </td>
                                <td class="text-flow col-xs-2 col-sm-2 col-lg-2 col-md-2 border-right1px">
                                  {{getEntity(scenario.eID).eName}}
                                </td>
                                <td class="text-flow col-xs-1 border-right1px">
                                  {{scenario.tID}}
                                </td>
                                <td class="text-flow col-xs-1border-right1px">
                                  {{scenario.attribute.level}}
                                </td>
                                <td class="text-flow col-xs-1">
                                  {{scenario.cr}}
                                </td>
                                <!-- <td class="text-flow col-xs-4">
                                      {{getScenario(sID).description}}
                                    </td>
                                    <td class="col-xs-1 no-padding">
                                      <div class="dropdown">
                                        <button
                                          class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                                          type="button" data-toggle="dropdown"
                                          >
                                          <div class="row strict">
                                            <div class="col-xs-8 span-on-button ">
                                              {{ getScenario(sID).persona.length}}
                                            </div>
                                            <div class="col-xs-2 col-xs-offset-1 pull-right ">
                                              <span class="caret"></span>
                                            </div>
                                          </div>
                                        </button>
                                        <ul class="dropdown-menu z-index">
                                          <li class="row strict"
                                            *ngFor="let p of getScenario(sID).persona">
                                            <div class="col-xs-12 dropdown-item menuItemsClrBlack pl-1">
                                              {{getPersona(p).pName}}
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td class="text-flow col-xs-1">
                                      {{getEntityForScenario(sID).eType}}
                                    </td>
                                    <td class="text-flow col-xs-2 col-sm-2 col-lg-2 col-md-2">
                                      {{getEntityForScenario(sID).eName}}
                                    </td>
                                    <td class="text-flow col-xs-1">
                                      {{getScenario(sID).tID}}
                                    </td>
                                    <td class="text-flow col-xs-1">
                                      {{getScenario(sID).priority}}
                                    </td>
                                    <td class="text-flow col-xs-1">
                                      {{getScenario(sID).cr}}
                                    </td> -->
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- suites tab end -->
            <!-- <div id="issues" class="tab-pane fade h-100 borderGray card p-1 mb-2 bg-white">
           <div class="row strict">
            <div class="bg-color-white">
             <h3>issues</h3>
             <p>yet to be decided</p>
            </div>
           </div>
          </div>
          <div ng-attr-id="analysis" class="tab-pane fade h-100 card p-1 mb-2 bg-white">
           <div class="row strict h-50 pb-1">
           </div>
           <div class="row strict h-50">
           </div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkTM" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkTM" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.testmanager' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="TmVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- The suite delete confirm message modal -->
  <div class="modal fade" id="suiteDeleteConfirmModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{'testManager.deletesuite' | translate}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" (click)="deleteSuite()"
              data-dismiss="modal">{{'yes' | translate}}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{'no' |
              translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- The test manager error message popup modal -->
  <div class="modal fade" id="testmanagerMsgPopup" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">
                    {{toastMsgPopup}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="testmanagerTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'testManager.tip1' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'testManager.tip2' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'testManager.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#testmanagerTip"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#testmanagerTip"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
</div>